/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useField } from 'formik';
import PropTypes from 'prop-types';

import Input from '@/components/Input';

import styles from '../ClaimBookingStep.module.scss';

type ClaimBookingFormInputProps = {
  name: string;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  [key: string]: any;
};

const ClaimBookingFormInput: React.FC<ClaimBookingFormInputProps> = ({ disabled, ...props }) => {
  const [field, meta, helpers] = useField(props);
  return (
    <>
      <Input
        {...field}
        {...props}
        disabled={disabled}
        iconDisabled={disabled}
        onChange={(value: any) => helpers.setValue(value)}
        className={styles.claimBookingInput}
      />
      {meta.error && meta.touched && (
        <div role="alert" className={styles.errorMessage}>
          {meta.error}
        </div>
      )}
    </>
  );
};
ClaimBookingFormInput.propTypes = {
  disabled: PropTypes.bool,
};

export default ClaimBookingFormInput;
